import {Col, DatePicker, Form, Input, Row, Select} from 'antd';
import React from 'react';
import AddFormComponent from '../common/AddFormComponent';
import EditFormComponent from '../common/EditFormComponent';
import {Arguments} from '../common/Arguments';
import SaveButtonComponent from '../common/SaveButtonComponent';
import {validateWhiteSpace} from '../common/ValidateWhiteSpace';

const layout = {
	labelCol: {span: 8},
	wrapperCol: {span: 16},
};

const tailLayout = {
	wrapperCol: {offset: 4, span: 16},
};

const AddPartyMember = () => {
	const currentUrl = window.location.href;
	const apiList = [Arguments.host + '/society_organization/party/consortium/api!addPartyMember.do'];

	return (currentUrl.endsWith('add') ? <AddFormComponent UserForm={PartyMemberForm} url={apiList}/> :
		<EditFormComponent UserForm={PartyMemberForm} url={apiList}/>);
};

const PartyMemberForm = ({onFinish, initialValues}) => {
	const [form] = Form.useForm();

	return (
		<Form
			{...layout}
			form={form}
			name="control-hooks"
			onFinish={onFinish}
			initialValues={initialValues}
			style={{maxWidth: 800, marginLeft: 40}}
		>
			<Row align="top">
				<Col span={12}>
					<Form.Item name="name" label="姓名" rules={[{required: true, validator: validateWhiteSpace}]}>
						<Input/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item name="born" label="出生日期" rules={[{required: true, message: '内容不能为空'}]}>
						<DatePicker placeholder="选择日期"/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item name="zzmm" label="政治面貌" rules={[{required: true, message: '内容不能为空'}]}
							   initialValue="中共党员">
						<Select>
							<Select.Option value="中共党员">中共党员</Select.Option>
							<Select.Option value="中共预备党员">中共预备党员</Select.Option>
							<Select.Option value="共青团员">共青团员</Select.Option>
							<Select.Option value="民革党员">民革党员</Select.Option>
							<Select.Option value="民盟盟员">民盟盟员</Select.Option>
							<Select.Option value="民建会员">民建会员</Select.Option>
							<Select.Option value="民进会员">民进会员</Select.Option>
							<Select.Option value="农工党党员">农工党党员</Select.Option>
							<Select.Option value="致公党党员">致公党党员</Select.Option>
							<Select.Option value="九三学社社员">九三学社社员</Select.Option>
							<Select.Option value="台盟盟员">台盟盟员</Select.Option>
							<Select.Option value="无党派人士">无党派人士</Select.Option>
							<Select.Option value="群众">群众</Select.Option>
						</Select>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item name="partyDate" label="入党时间" rules={[{required: true, message: '内容不能为空'}]}>
						<DatePicker placeholder="选择日期"/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item
						name="sszb" label="所属支部"
						rules={[{required: true, validator: validateWhiteSpace}]}
					>
						<Input/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item
						name="partyZhiWu" label="党内职务"
						rules={[{required: true, validator: validateWhiteSpace}]}
					>
						<Input/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="workUnit" label="工作单位"
						rules={[{required: true, validator: validateWhiteSpace}]}
					>
						<Input/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item
						name="zhiWu" label="职务"
						rules={[{required: true, validator: validateWhiteSpace}]}>
						<Input/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item
						name="zhiJi" label="职级"
						rules={[{required: true, message: '内容不能为空'}]}
					>
						<Input/>
					</Form.Item>
				</Col>
			</Row>

			<Form.Item {...tailLayout}>
				<SaveButtonComponent/>
			</Form.Item>
		</Form>
	);
};

export default AddPartyMember;
